import React from 'react';
import { Typography } from '@mui/material';
import { ProjektDetailSection } from '@/app/components/sections/ProjektDetailSection';
import RootLayout from '@/app/layout';
import Head from 'next/head';

export default function ProjektDetail({ data, metadata, nextProjectId, previousProjectId }) {
  return (
    <RootLayout>
      <Head>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        <meta name="keywords" content={metadata.keywords} />
        <link rel="canonical" href={metadata.canonicalUrl} />
      </Head>
      {data ? (
        <ProjektDetailSection content={data} nextProjectId={nextProjectId} previousProjectId={previousProjectId} />
      ) : (
        <Typography variant="h6" align="center">
          Lädt...
        </Typography>
      )}
    </RootLayout>
  );
}

export async function getServerSideProps(context) {
  const { id } = context.params;

  const res = await fetch(`${process.env.NEXT_PUBLIC_API_DOMAIN}/api/getProjekte?id=${id}`);
  const project = await res.json();

  if (!project) {
    return {
      notFound: true,
    };
  }

  const metadata = {
    title: `Marlene Gujan Architektur AG | ${project.titel}`,
    description: project.beschreibung ? project.beschreibung.slice(0, 160) : 'Projektdetailansicht',
    keywords: `Projekt, Architektur, ${project.titel}, ${project.projektart}, Gujan Architektur, Marlene Gujan Architektur AG, Architekt`,
    canonicalUrl: `https://www.gujan-architektur.ch/projekte/${project.projekt_id}`
  };

  return {
    props: {
      data: {
        projekt_id: project.projekt_id,
        titel: project.titel,
        untertitel: project.untertitel,
        beschreibung: project.beschreibung,
        bauinfos: project.bauinfos,
        projektart: project.projektart,
        jahr: project.jahr,
      },
      metadata: metadata,
      nextProjectId: project.nextProjectId,
      previousProjectId: project.previousProjectId,
    },
  };
}
